<template>
    <v-dialog v-model="dialogOpen" :width="width">
        <BaseCard class="tw-border-0">
            <BaseCardHeader
                v-if="!hideHeader"
                :class="cn(headerComputedClass, props.headerClass)"
            >
                <div class="tw-flex tw-flex-col tw-gap-2">
                    <BaseCardTitle
                        :class="cn(titleComputedClass, props.titleClass)"
                    >
                        {{ title || 'Test Dialog' }}
                    </BaseCardTitle>
                    <span class="tw-text-sm tw-text-gray-500" v-if="subtitle">
                        {{ subtitle }}
                    </span>
                </div>
                <v-btn icon @click="onClose" v-if="showCloseButton && onClose">
                    <v-icon :color="webAppFontColor"> mdi-close </v-icon>
                </v-btn>
            </BaseCardHeader>
            <BaseCardContent
                :class="cn(contentComputedClass, props.contentClass)"
                :defaultPadding="props.defaultPadding"
            >
                <slot></slot>
            </BaseCardContent>
            <BaseCardFooter v-if="$slots.actions">
                <BaseCardActions>
                    <slot name="actions"></slot>
                </BaseCardActions>
            </BaseCardFooter>
        </BaseCard>
    </v-dialog>
</template>
<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import {
    BaseCard,
    BaseCardActions,
    BaseCardContent,
    BaseCardHeader,
    BaseCardFooter,
    BaseCardTitle,
} from '@vibefam/card'
import { cn, getBgColorClass, type MainColorVariant } from '../utils'
import { useStudioStore } from '@/components/bookclass/stores/studioStore'

const props = withDefaults(
    defineProps<{
        value: boolean
        width?: number | string
        contentClass?: HTMLAttributes['class']
        headerClass?: HTMLAttributes['class']
        titleClass?: HTMLAttributes['class']
        headerColor?: MainColorVariant
        hideHeader?: boolean
        defaultPadding?: boolean
        title?: string
        subtitle?: string
        showCloseButton?: boolean
        onClose?: () => void
    }>(),
    {
        defaultPadding: true,
    }
)

const emit = defineEmits<{
    (e: 'input', value: boolean): void
}>()
const dialogOpen = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value),
})

const headerComputedClass = computed(() => {
    const headerClass = 'tw-flex tw-flex-row tw-justify-between'

    if (props.headerColor)
        return cn(headerClass, getBgColorClass(props.headerColor))

    return headerClass
})
const titleComputedClass = computed(() => {
    return {
        ['tw-text-white']: props.headerColor,
    }
})

const contentComputedClass = computed(() => {
    return {
        ['tw-mt-5']: props.headerColor,
    }
})

const studioStore = useStudioStore()
const webAppFontColor = computed(() => {
    if (studioStore.studio) {
        return studioStore.studio.webAppFontColor || 'primary'
    }
    return 'primary'
})
</script>
